// @flow
import React, { Fragment, useState, useContext, useEffect } from 'react';
import cookie from 'js-cookie';
import { get } from 'lodash';

import ReactAppContext from 'Context/ReactAppContext';
import ReactResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { setInLocalStorage, getFromLocalStorage } from 'Client/local-storage-api';
import { addTranslationKeys } from 'Src/i18n';
import {
  PopinNewsletter,
  POPIN_NEWSLETTER,
} from 'Components/widgets/popin-newsletter/PopinNewsletter.jsx';
import { ABTestContext } from 'Context/ABTestContext';

import { CookieWarning } from 'Components/widgets/cookie-warning/CookieWarning.jsx';
import { COOKIE_WARNING_LOCALSTORAGE_KEY } from 'Components/widgets/cookie-warning/constants';
import { Footer } from './Footer.jsx';

type Props = {
  config: CMSContent,
  legalInformations: {
    newsletter: Array<{
      id: number,
      description: string,
    }>,
  },
  newsletters: Array<{
    id: string,
    description: string,
  }>,
};

export function FooterContainer(props: Props) {
  const ABTests = useContext(ABTestContext);
  const { isAppMounted } = useContext(ReactResponsiveContext);
  const conditionToShowPopin =
    isAppMounted &&
    ABTests['ab-test-popinNewsletter'] === '1' &&
    getFromLocalStorage(POPIN_NEWSLETTER) !== 'viewed';
  const appContext = useContext(ReactAppContext);
  const {
    newsletters,
    legalInformations,
    config: { cookieWarning, memberSpace, footer, webCallback, common },
  } = props;
  const { approve, label, layer, ...otherCookieWarningProps } = cookieWarning;

  addTranslationKeys({
    common,
    webCallback: {
      ...webCallback,
      ...common.dateTime,
    },
    newsletter: props.config.newsletter,
    memberSpace,
  });

  const policies =
    appContext.locale === 'zh-CN'
      ? [
          {
            imageSrc: 'https://ns.clubmed.com/it/2019/footer/logo_cn_gov1.png',
            label: '沪公网安备31010102005123号',
            url: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010102005123',
          },
          {
            imageSrc: 'https://ns.clubmed.com/it/2019/footer/logo_cn_gov2.png',
            label: '上海工商',
            url:
              'http://www.sgs.gov.cn/lz/licenseLink.do?method=licenceView&entyId=gs20140504000004692',
          },
        ]
      : [];

  const [popinShow, setPopinShow] = useState(conditionToShowPopin);

  const onClosePopin = () => {
    setPopinShow(false);
    setInLocalStorage(POPIN_NEWSLETTER, 'viewed');
  };

  useEffect(() => setPopinShow(conditionToShowPopin), [conditionToShowPopin]);

  return (
    <Fragment>
      {popinShow && (
        <PopinNewsletter
          checkboxes={newsletters}
          legalInformations={legalInformations ? legalInformations.newsletter : []}
          onClose={onClosePopin}
        />
      )}
      <CookieWarning
        {...otherCookieWarningProps}
        buttonLabel={approve}
        closeLabel={get(props, 'config.common.close')}
        layerInfo={layer}
        text={label}
        isAppMounted={isAppMounted}
        isApproved={!!cookie.get(COOKIE_WARNING_LOCALSTORAGE_KEY)}
      />
      <Footer
        policies={policies}
        annexes={footer.annexes}
        contacts={footer.contactsBar}
        seo={footer.seo}
        socialNetworks={footer.socialNetworks}
        tabText={footer.contactsBarLabel}
        tripAdvisor={footer.tripAdvisor}
        websites={footer.websites}
      />
    </Fragment>
  );
}
